import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/parcheggi.html',
    name: 'parcheggi',
    component: () => import('../views/ParkingMap.vue')
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/PrenotazioneAsporto',
    name: 'PrenotazioneAsporto',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/PrenotazioneAsporto.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/ConfermaPrenotazione',
    name: 'ConfermaPrenotazione',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ConfermaPrenotazione" */ '../views/ConfermaPrenotazione.vue')
  },
  {
    path: '/RiepilogoPrenotazione',
    name: 'RiepilogoPrenotazione',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "RiepilogoPrenotazione" */ '../views/RiepilogoPrenotazione.vue')
  },
  {
    path: '/RiepilogoPrenotazioneAttesa',
    name: 'RiepilogoPrenotazioneAttesa',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "RiepilogoPrenotazione" */ '../views/RiepilogoPrenotazioneAttesa.vue')
  },
  {
    path: '/DeletePrenotazione',
    name: 'DeletePrenotazione',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "DeletePrenotazione" */ '../views/DeletePrenotazione.vue')
  },
  {
    path: '/AdminCsvDownload',
    name: 'AdminCsvDownload',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "AdminCsvDownload" */ '../views/AdminCsvDownload.vue')
  },
  {
    path: '/ModificaCoperti',
    name: 'ModificaCoperti',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "AdminCsvDownload" */ '../views/ModificaCoperti.vue')
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
